module.exports = __webpack_public_path__ + "static/media/icon_modal_alert.69cd81c9.svg";